import { useEffect, useState } from 'react';
import { BedroomData } from '@/components/BedroomDialog';
import { supabase } from '@/integrations/supabase/client';
import { getImageUrl } from '@/lib/image-url';

const staticBedrooms: Omit<BedroomData, 'images'>[] = [
  {
    id: 'chambre-1',
    name: 'Suite parentale',
    beds: '1 lit double',
    description: 'Chambre parentale avec lit double confortable et rangements. Accès direct à la terrasse avec vue sur le jardin et salle de bain privative.',
    features: [
      { name: 'Lit double 160×200', icon: 'bed-double' },
      { name: 'Salle de bain privative avec douche', icon: 'bath' },
      { name: 'Dressing aménagé', icon: 'shirt' },
    ],
  },
  {
    id: 'chambre-2',
    name: 'Chambre accès terrasse',
    beds: '1 lit double',
    description: 'Chambre calme et lumineuse avec un lit double et une fenêtre donnant sur le jardin.',
    features: [
      { name: 'Lit double 140×200', icon: 'bed-double' },
      { name: 'Accès terrasse', icon: 'sun' },
      { name: 'Commode', icon: 'shirt' },
    ],
  },
  {
    id: 'chambre-3',
    name: 'Chambre enfants',
    beds: '2 lits simples',
    description: 'Chambre idéale pour les enfants ou amis avec deux lits simples. Espace lumineux et fonctionnel avec accès terrasse.',
    features: [
      { name: '2 lits simples 90×200', icon: 'bed' },
      { name: 'Rangements', icon: 'shirt' },
      { name: 'Jeux', icon: 'toy-brick' },
      { name: 'Petit bureau', icon: 'lamp-desk' },
    ],
  },
];

export function useBedrooms(): BedroomData[] {
  const [rows, setRows] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const sections = staticBedrooms.map((b) => `bedroom-${b.id}`);
    supabase
      .from('site_images')
      .select('section, url, order')
      .in('section', sections)
      .order('order', { ascending: true })
      .then(({ data }) => {
        if (!data) return;
        const grouped: Record<string, string[]> = {};
        for (const row of data) {
          if (!grouped[row.section]) grouped[row.section] = [];
          grouped[row.section].push(getImageUrl(row.url));
        }
        setRows(grouped);
      });
  }, []);

  return staticBedrooms.map((b) => ({
    ...b,
    images: rows[`bedroom-${b.id}`] ?? [],
  }));
}
